import { render } from "./btn_reload.vue?vue&type=template&id=982c1928"
import script from "./btn_reload.vue?vue&type=script&lang=js"
export * from "./btn_reload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__